import '../css/bootstrap.scss';

/* eslint-disable */
import '@popperjs/core';
import * as bootstrap from 'bootstrap';

// Expose the Collapse (etc.) API globally so other bundles/inline scripts can
// control component instances directly instead of simulating clicks.
window.bootstrap = bootstrap;
/* eslint-enable*/
